export const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 10,
  total: 0,
  showSizeChanger: false,
  showQuickJumper: false,
  pageSizeOptions: [5, 10, 20, 50, 100],
  showTotal: (total: number, range: [number, number]) =>
    `${range[0]}-${range[1]} of ${total}`,
};
